<script>
  let { 
    loading,
    absenceMode = $bindable(false),
    halfDayMode = $bindable(false),
    showPresences = $bindable(true),
    showAbsences = $bindable(true),
    showDutyShifts = $bindable(true),
    role = 'viewer' 
  } = $props();
  let creator = $derived(["admin", "manager"].includes(role));
</script>

<!-- A header row for some extra buttons -->
<header class="flex items-center justify-end gap-2 top-0 z-10 bg-white mb-6">
  
  <!-- Creator can toggle mode selections -->
  {#if creator}
    <button type="button" disabled={loading} class="button no-bg" onclick={() => absenceMode = !absenceMode}>Mode: {absenceMode ? "Absence" : "Présence"}</button>
    <button type="button" disabled={loading} class="button no-bg" onclick={() => halfDayMode = !halfDayMode}>Sélection: {halfDayMode ? "Demi-journée" : "Journée"}</button>
  {/if}
  
  <button type="button" disabled={loading} class="button no-bg" onclick={() => showPresences = !showPresences}>
    <i class={`fal ${showPresences ? 'fa-eye' : 'fa-eye-slash'}`}></i>
    <span>Présences</span>
  </button>

  <button type="button" disabled={loading} class="button no-bg" onclick={() => showAbsences = !showAbsences}>
    <i class={`fal ${showAbsences ? 'fa-eye' : 'fa-eye-slash'}`}></i>
    <span>Absences</span>
  </button>

  <button type="button" disabled={loading} class="button no-bg" onclick={() => showDutyShifts = !showDutyShifts}>
    <i class={`fal ${showDutyShifts ? 'fa-eye' : 'fa-eye-slash'}`}></i>
    <span>Gardes</span>
  </button>
  
</header>